// extracted by mini-css-extract-plugin
export var content = "_64-3";
export var list = "_64-4";
export var settingsContent = "_64-7";
export var settingsPanel = "_64-8";
export var state = "_64-6";
export var triggerBadge = "_64-2";
export var triggerButton = "_64-1";
export var triggerShell = "_64-0";
export var unreadDot = "_64-5";